import React from 'react'
import "./Header.css"
import { Container } from 'react-bootstrap'

const Header = () => {

    return (
        <div className='Header'>
            <h2>Compare Devices</h2>
            <span>Easily Compare the Latest Tracking Devices – Use our advanced filters to find the perfect solution tailored to your business needs.</span>
        </div>
    )
}

export default Header
